import React, { createContext, useContext, useMemo } from 'react';
import { useLanguage } from './LanguageContext';
import rawData from '../data/tarkovData.json';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const { language } = useLanguage();

  const processedData = useMemo(() => {

    // 1. QUESTS
    const quests = Object.values(rawData.tasks || {}).map(task => {
      const localeData = task.locales[language] || task.locales['en'];

      return {
        id: task.id,
        minPlayerLevel: task.minPlayerLevel,
        taskRequirements: task.taskRequirements,
        kappaRequired: task.kappaRequired,
        trader: task.trader,
        wikiLink: task.wikiLink,
        mapName: localeData?.mapName || task.map?.name || 'Multiple',
        englishName: task.locales['en']?.name || task.name,
        name: localeData?.name || task.name,
        objectives: localeData?.objectives || task.objectives,
      };
    });

    // 2. HIDEOUT
    const hideout = Object.values(rawData.hideout || {}).map(station => {
      const localeData = station.locales[language] || station.locales['en'];

      return {
        id: station.id,
        englishName: station.locales['en']?.name || station.name,
        name: localeData?.name || station.name,
        levels: localeData?.levels || station.levels,
        imageLink: station.imageLink,
      };
    });

    // 3. TRADERS (Yeni Eklenen Veri)
    const traders = Object.values(rawData.traders || {}).map(trader => {
      const localeData = trader.locales[language] || trader.locales['en'];
      return {
        id: trader.id,
        normalizedName: trader.normalizedName,
        imageLink: trader.imageLink,
        name: localeData?.name || trader.name
      };
    });

    // 4. KAPPA ITEMS
    const collectorTask = rawData.tasks['5c51aac186f77432ea65c552'];
    const kappaItems = collectorTask
      ? (collectorTask.locales[language] || collectorTask.locales['en']).objectives
        .filter(obj => obj.item)
        .map(obj => ({
          id: obj.item.id,
          name: obj.item.name,
          shortName: obj.item.shortName,
          iconLink: obj.item.iconLink,
        }))
      : [];

    // 5. TÜM VERİYİ DÖNDÜR (Return kısmı her şeyin en altında olmalı)
    return {
      quests,
      hideout,
      traders,
      kappaItems,
      isLoaded: true
    };
  }, [language]);

  return (
    <DataContext.Provider value={processedData}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);